import { createStore, StoreCore } from "@priolo/jon";
import { URL_PAR } from 'stores/route/utils/types';
import { queryUpdateUrl } from "./utils/query";
import { debounce } from "utils";



/**
 * Si occupa di gestire lo store dei dati nella query string
 * questi servono per i filtri i sort e alcune selezioni 
 */
const setup = {

	state: {
		/** Blocca i filtri della QUERY-URL */
		blockFilter: localStorage.getItem(`block-filter`) == "true" || false,
		/** questo valore mi serve principalmente per notificare quando cambia la queryUrl */
		queryUrl: window.location.search,
	},

	getters: {
		/**
		 * restituisce il valore di un parametro memorizzato nella QUERY-URL
		 */
		getSearchUrl: ((names: string | string[], store?: any): string | string[] => {
			// devo usare la QUERY-URL memorizzata nello store perche' quella di localhost si aggiorna in ritardo
			const searchParams = new URLSearchParams(store.state.queryUrl)
			if (typeof names == "string") return searchParams.get(names)
			if (!names) return []
			return names.map(name => searchParams.get(name))
		}) as {
			(input: string, store?: any): string
			(input: string[], store?: any): string[]
		},
		/**
		 * restituisce gli "items" messi in ordine in base ai parametri dell'url
		 * - items da mettere in ordine
		 * - (opz) map è un dictionary con dentro le funzioni da usare per l'ordinamento
		 * - (opz) sortNameDefault è il nome proprietà da "sortare" ne caso non sia indicata nell'url
		 * - (opz) orderDefault l'ordine decrescente/crescente da usare nel caso non sia indicato nell'url 
		 */
		getSorted: ({ items, map, sortNameDefault = "name", orderDefault }: PayloadGetSorted, store?: QueryStringStore) => {
			if (!items || items.length < 2) return items
			let sortName = store.getSearchUrl("sortName")
			let isDes = store.getSearchUrl("isDes") == "true"
			if (!sortName || sortName.length == 0) {
				sortName = sortNameDefault
				isDes = orderDefault != null ? orderDefault : isDes
			}
			const extractor = map?.[sortName]
			if (!extractor) {
				const first = items[0][sortName]
				const fnCompare = typeof first == "string"
					? (a: any, b: any) => a[sortName]?.localeCompare(b[sortName])
					: (a: any, b: any) => (a[sortName] < b[sortName] ? -1 : 1)
				return items.sort((a, b) => fnCompare(a, b) * (isDes ? -1 : 1))
			}
			return items.sort(
				(a, b) => (extractor(a) < extractor(b) ? -1 : 1) * (isDes ? -1 : 1)
			)
		},
	},

	actions: {
		/** aggiorno la QUERY-URL per intero */
		updateQueryUrl: (_: void, store?: QueryStringStore) => {
			//const queryParams: URLSearchParams = new URLSearchParams(store.state.queryUrl)
			const queryParams: URLSearchParams = new URLSearchParams(window.location.search)
			if (!store.state.blockFilter) {
				URL_PAR_FILER.forEach(par => queryParams.delete(par))
			}
			queryParams.set(URL_PAR.UPDATE, (Math.round(Math.random() * 999)).toString())
			const queryUrl = queryParams.toString()
			window.history.replaceState(null, null, `?${queryUrl}`)
			store.state.queryUrl = queryUrl
		},

		/** 
		 * Dato un array KEY-VALUE modifico la QUERY-URL
		 * es. param = [ "date.sel", "2024-01-01",   "text", "pippo",   "selected", null ]
		 * "selected" verrà eliminato dalla query string
		*/
		setSearchUrl: (params: string[], store?: QueryStringStore) => {
			const queryUrl = queryUpdateUrl(params, store.state.queryUrl)
			debounce(
				"store-query-change",
				() => window.history.replaceState(null, null, `?${queryUrl}`),
				100
			)
			store.setQueryUrl(queryUrl)
		},
		/** 
		 * inserisco nella QUERY-URL un nome che verra' poi abbinato ad una campo da "sortare" 
		 * */
		setSort: (sortName: string, store?: QueryStringStore) => {
			const oldSortName = store.getSearchUrl("sortName")
			const oldIsDes = store.getSearchUrl("isDes") == "true"
			let sortIsDes = oldSortName == sortName ? !oldIsDes : oldIsDes
			store.setSearchUrl(["sortName", sortName])
			store.setSearchUrl(["isDes", String(sortIsDes)])
		},
	},

	mutators: {
		setQueryUrl: (queryUrl: string) => ({ queryUrl }),
		setBlockFilter: (blockFilter: boolean) => {
			localStorage.setItem(`block-filter`, String(blockFilter))
			return { blockFilter }
		},
	},
}

type PayloadGetSorted = {
	items?: any[]
	map?: { [key: string]: (v: any) => any }
	sortNameDefault?: string
	orderDefault?: boolean
}

export type QueryStringState = typeof setup.state
export type QueryStringGetters = typeof setup.getters
export type QueryStringActions = typeof setup.actions
export type QueryStringMutators = typeof setup.mutators
export interface QueryStringStore extends StoreCore<QueryStringState>, QueryStringGetters, QueryStringActions, QueryStringMutators {
	state: QueryStringState
}
const querySo = createStore(setup) as QueryStringStore
export default querySo



// let currentPathname = location.pathname;

// const observer = new MutationObserver(() => {
//     if (location.pathname !== currentPathname) {
//         currentPathname = location.pathname;

//         let value = querySo.state.queryUrl
// 		const queryParams = new URLSearchParams(value)
// 		queryParams.delete(URL_PAR.TEXT)
// 		value = queryParams.toString()

// 		querySo.state.queryUrl = value
// 		window.history.replaceState(null, null, `?${value}`)
//     }
// });
// observer.observe(document, { subtree: true, childList: true });

const URL_PAR_FILER: URL_PAR[] = [
	URL_PAR.TEXT,
	URL_PAR.SORT_NAME,
	URL_PAR.SORT_DES,
	URL_PAR.DATE_SEL,
	URL_PAR.GROWUNIT_SEL,
	URL_PAR.CYCLE_SEL,
	URL_PAR.TASK_SEL,
	URL_PAR.CROP_SEL,
	URL_PAR.MAP_LAYER,
]